import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckStep',
  props: {
  title: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
},
  emits: ["to"],
  setup(__props) {

const props = __props





const isActiveOrChecked = computed(() => {
  return props.active || props.checked
})

const color = computed(() => {
  return isActiveOrChecked.value ? "var(--ahead-primary-color)" : "var(--dark-grey)"
})

const textColor = computed(() => {
  return isActiveOrChecked.value ? "#0B0101" : "var(--dark-grey)"
})

const iconName = computed(() => {
  return props.checked ? "check-circle" : "record"
})

const type = computed(() => {
  return props.checked ? "bold" : "outline"
})

return { __sfc: true,props, isActiveOrChecked, color, textColor, iconName, type, Icon }
}

})